export default "__VITE_ASSET__MKOWoHLk__"